import { z } from 'zod';

/**
 * Schema for search params in _authenticated route
 * Used for session restoration and payment recovery
 */
export const authSearchSchema = z
  .object({
    orderId: z.string().optional(),
    orderid: z.string().optional(), // legacy lowercase version
    device: z.string().optional(),
    style: z.string().optional(),
    openpayment: z.string().optional(),
  })
  .catch({});

export type TAuthSearchParams = z.infer<typeof authSearchSchema>;

export const insightsCategorySearchSchema = z
  .object({
    type: z.enum(['articles', 'collections', 'mixed']).default('articles'),
  })
  .catch({ type: 'articles' as const });

export type TInsightsCategorySearch = z.infer<typeof insightsCategorySearchSchema>;
export type TInsightsCategoryType = 'articles' | 'collections' | 'mixed';

export const insightsIndexSearchSchema = z
  .object({
    category: z.coerce.number().optional(),
    q: z.string().optional(),
  })
  .catch({});

export type TInsightsIndexSearch = z.infer<typeof insightsIndexSearchSchema>;

export const articleSearchSchema = z
  .object({
    id: z.coerce.number().optional(),
    source: z.string().optional(),
    stepTrigger: z.string().optional(),
    onboardingStep: z.coerce.number().optional(),
  })
  .catch({});

export const onboardingLoaderSearchSchema = z
  .object({
    step: z.coerce.number().positive().int(),
  })
  .catch({ step: 1 });
